import loader from '../../common/loader';
import cookie from '../../common/cookie';
import { loginCookie } from '../login/common'; // 企鹅电竞

var jsApi = 'https://cdn.egame.qq.com/pgg_libs_act/outlibs/dist/index.min.js';
var qqAppid = 'wx9ccf6602d778eca7';
var wxAppid = '1105198412';
var miloSelfConfig = {
  isMiloWayCookies: false,
  appName: 'egame'
};

var loadJsApi = function loadJsApi() {
  return new Promise(function (resolve, reject) {
    console.log('调用jsBridge');

    if (window.pggLibs) {
      console.log('window.pggLibs', window.pggLibs);
      resolve(window.pggLibs);
      return;
    }

    loader.loadScript(jsApi).then(function (isLoad) {
      if (isLoad && window.pggLibs) {
        console.log('window.pggLibs', window.pggLibs);
        resolve(window.pggLibs);
      } else {
        reject();
      }
    })["catch"](function (e) {
      reject(e);
    });
  });
};

var loginByQQAndWX = function loginByQQAndWX() {
  loadJsApi().then(function (JsBridge) {
    JsBridge["native"].ui.openView({
      url: 'login',
      options: 'qgameapi://login',
      onclose: function onclose(e) {
        if (e && e.data) {
          var t = typeof e.data.resultCode === 'undefined' ? e.code : e.data.resultCode;

          if (t == 0) {
            window.location.reload();
          }
        }
      }
    });
  })["catch"](function () {});
};

var loginByWX = function loginByWX() {
  loginByQQAndWX();
};

var loginByQQ = function loginByQQ() {
  loginByQQAndWX();
};

var setAppCookie = function setAppCookie() {
  console.log('beforeSetCookie');
  return new Promise(function (resolve, reject) {
    var logintype = cookie.get('pgg_type');
    var mobileqopenid = cookie.get('pgg_openid');
    var mobileqtoken = cookie.get('pgg_access_token');
    var wopenid = cookie.get('pgg_openid');
    var waccesstoken = cookie.get('pgg_access_token');
    var quin = cookie.get('uin');
    var qskey = cookie.get('skey');

    if (logintype) {
      if (logintype == 2) {
        loginCookie.setQQ({
          acctype: 'wx',
          appid: wxAppid,
          openid: wopenid,
          access_token: waccesstoken
        }, 7200);
      }

      if (logintype == 1 && mobileqopenid && mobileqtoken) {
        window.iUseQQConnect = 1;
        loginCookie.setLocal({
          acctype: 'qc',
          appid: qqAppid,
          openid: mobileqopenid,
          access_token: mobileqtoken
        }, 7200);
        loginCookie.setQQ({
          acctype: 'qc',
          appid: qqAppid,
          openid: mobileqopenid,
          access_token: mobileqtoken
        }, 7200);
      } else if (logintype == 1 && quin && qskey) {
        loginCookie.setQQ({
          uin: quin,
          skey: qskey
        }, 7200);
      }

      resolve();
    } else {
      reject();
    }
  });
};

var getLoginType = function getLoginType() {
  return new Promise(function (resolve) {
    var logintype = cookie.get('pgg_type');

    if (logintype == 2) {
      resolve('wx');
    }

    if (logintype === 1 && cookie.get('pgg_openid') && cookie.get('pgg_access_token')) {
      resolve('qc');
    } else if (logintype === 1 && cookie.get('uin') && cookie.get('skey')) {
      resolve('pt');
    }

    resolve(null);
  });
};

var logout = function logout() {
  loginCookie.clearQQ();
  loginCookie.clearLocal();
  cookie.clear('pgg_openid', 'qq.com', '/');
  cookie.clear('pgg_access_token', 'qq.com', '/');
  cookie.clear('pgg_uid', 'qq.com', '/');
  cookie.clear('appid', 'qq.com', '/');
};

var egame = {
  loadJsApi: loadJsApi,
  loginByWX: loginByWX,
  loginByQQ: loginByQQ,
  loginByQQAndWX: loginByQQAndWX,
  setAppCookie: setAppCookie,
  getLoginType: getLoginType,
  logout: logout,
  miloSelfConfig: miloSelfConfig
};
export default egame;